define.alias("ember-composable-helpers/helpers/reduce", "settings/helpers/reduce");